import * as Yup from 'yup';

import {
  CasButton,
  CasDisplayField,
  CasEditForm,
  CasMessageDialog,
  CasRHFDropzoneUpload,
  CasStackRow,
  CasTable,
} from 'src/compass/shared/components';
import { DateFormat, formatDateTime } from 'src/compass/shared/util/casMoment';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import { getParsedHTML } from 'src/compass/shared/util/getParsedHTML';

const Schema = Yup.object().shape({
  files: Yup.array()
    .of(Yup.mixed().required('File is required.'))
    .min(1, 'At least one file is required.')
    .required('Files are required.'),
});

interface Props {
  row?: any;
  onSaved: Function;
}

const getStatusMessage = (row?: any) => {
  if (row.isClosed && !row.hasUpload) return 'Request has been closed';
  if (row.isClosed) return 'Compass has finished reviewing & processing these files';
  return 'Compass review is in process';
};

export default function PublicUploadFileForm({ row, onSaved: parmOnSaved }: Props) {
  const successDialog = useCasBoolean();

  return (
    <>
      <CasEditForm
        fileUpload
        defaultValues={row}
        onSaved={successDialog.setTrue}
        entity="Public/Uploads"
        schema={Schema}
      >
        <CasStackRow className="bordered-cells">
          <CasDisplayField label="Email" value={row?.email} />
          <CasDisplayField label="Upload" value={row?.type} />
        </CasStackRow>
        <CasStackRow className="bordered-cells">
          <CasDisplayField label="Request" value={getParsedHTML(row?.requestProperty)} />
        </CasStackRow>
        {(row?.hasUpload || row?.isClosed) ? (
          <>
            <CasStackRow className="bordered-cells">
              <CasDisplayField
                label="Status"
                value={getStatusMessage(row)}
              />
              <CasDisplayField
                label="Date Submitted"
                value={formatDateTime(row.dateSubmitted, DateFormat.MDY_HM)}
              />
            </CasStackRow>
            <CasTable
              data={{ result: row.files }}
              columns={[{ field: 'name' }, { field: 'fileSize', label: 'Size' }]}
            />
          </>
        ) : (
          <>
            <CasRHFDropzoneUpload name="files" multiple />
            <CasStackRow justifyContent="flex-end">
              <CasButton type="submit">Submit</CasButton>
            </CasStackRow>
          </>
        )}
      </CasEditForm>
      {successDialog.value && (
        <CasMessageDialog
          onClose={() => {
            parmOnSaved();
            successDialog.setFalse();
          }}
        >
          Your files have been successfully received.  Thanks
        </CasMessageDialog>
      )}
    </>
  );
}
